// Action creators extracted from LoginModule.js

import {
  AUTH_SUPERADMIN_SUCCESS,
  SET_DESIGNATION_LIST,
  AUTH_USER_SUCCESS,
  LOGOUT_USER_SUCCESS,
  SET_LOADING_STATE,
  SET_GLOBAL_TRAY_ENABLED_STATE,
  SET_GLOBAL_TRAY_RETRACTED_STATE,
  SET_GLOBAL_TRAY_UNREAD_COUNT,
  SET_TOAST_MSG,
  CLEAR_TOAST_MSG,
  SET_ACTIVE_TAB,
  SET_CURRENT_PAGE_TITLE,
  UPDATE_INPUT_FIELD,
  SET_CURRENT_SCREEN,
  SET_LOGIN_ERROR,
  SET_HELP_CENTER_VIDEO_DIRECT_LINK,
  RETENTION_MODAL_STATUS,
  BIFURCATION_MODAL_STATUS,
  UPDATE_ORGANIZATION_FILTERS,
  INIT_ORGANIZATION_FILTERS,
  UPDATE_ORGANIZATION_LIST_DATA,
  SET_BIFURCATION_ACTION,
  SET_REDIRECT_URL,
  SET_IS_USER_FROM_PUBLIC_ACCESS,
  SET_CHILD_STATUS,
  SET_PRODUCT_UPDATE_DIRECT_LINK,
  SET_PRODUCT_UPDATE_MODAL_OPEN,
  SET_PRODUCT_UPDATE_MODAL_VISIBLE,
  SET_LAST_CHILD_STATUS,
  SET_CHILD_DATA,
  SET_IS_UNMAPPED_PARENT,
  SET_PARENT_LOGIN_TAB,
  SET_AUTH_REGION,
  SET_PARENT_INVITE_CODE,
  UPDATE_USER_INFO,
  UPDATE_INVITED_FAMILY_DATA,
  UPDATE_INVITED_FAMILY_CHILD_DATA,
  UPDATE_ORGANIZATION_SWITCHER_DETAILS,
  SET_IDENTITY_POOL_DETAILS,
  SET_USER_IDENTITY_DETAILS,
  SET_IDENTITY_SCREEN_FILTERS,
  SET_PORTAL_TYPE,
  SET_SELECTED_ICON,
  SET_MESSAGING_USER_ID,
  SET_MESSAGING_CHAT_ID,
  SET_UNDER_MAINTENANCE,
  TOGGLE_IS_SPRINKLR_CHAT_OPEN,
  UPDATE_SPRINKLR_UNREAD_MESSAGE_COUNT,
  SET_IS_USER_CONFIGURATIONS_FETCHED,
  SET_USER_COURSES_IDS,
  SET_IDP_LIST,
  SET_PUBLIC_TOKEN,
  ADD_BANNER,
  REMOVE_BANNER,
  SET_GLOBAL_HEADER_VISIBILITY,
  SET_GLOBAL_HEADER_VISIBILITY_ON_CURRENT_ROUTE,
  SET_DEMO_DAY_BANNER_VISIBILITY,
  UPDATE_SESSION_VERIFICATION_DETAILS,
  SET_SHORTCUT_TOAST_VISIBILITY,
  SET_ORG_WORKSPACE_DETAILS,
  CLEAR_ORG_WORKSPACE_DETAILS,
  SET_CHILD_ID,
  SENTRAL_PORTAL_DETAILS,
  SET_SSO_REQUEST_INITIATED_FAILED,
  SET_SAML_INITIATED_DETAILS,
  UPDATE_MFA_VERIFICATION_DETAILS,
  SETUP_MFA_VERIFICATION_DETAILS,
} from "./LoginConstants";

// Action Creators
export const updateOrganizationListData = data => {
  return { type: UPDATE_ORGANIZATION_LIST_DATA, payload: data };
};

export const setDesignationList = data => {
  return { type: SET_DESIGNATION_LIST, payload: data };
};

export const authSuperAdminSuccess = data => {
  return { type: AUTH_SUPERADMIN_SUCCESS, payload: data };
};

export const updateOrganizationFilters = data => {
  return {
    type: UPDATE_ORGANIZATION_FILTERS,
    data,
  };
};

export const initOrganizationFilters = () => {
  return {
    type: INIT_ORGANIZATION_FILTERS,
  };
};

export const authUserSuccessAction = data => {
  return {
    type: AUTH_USER_SUCCESS,
    payload: data,
  };
};

export const setUserCoursesIds = data => {
  return {
    type: SET_USER_COURSES_IDS,
    payload: data,
  };
};

export const setIdpsList = data => {
  return {
    type: SET_IDP_LIST,
    payload: data,
  };
};

export const updateInputField = (screenName, data) => {
  return { type: UPDATE_INPUT_FIELD, payload: { screenName, data } };
};

export const setCurrentScreen = data => {
  return { type: SET_CURRENT_SCREEN, data: data };
};

export const setHelpCenterVideoDirectLinkOpen = value => {
  return { type: SET_HELP_CENTER_VIDEO_DIRECT_LINK, data: value };
};

export const setRetentionModalStatus = status => {
  return { type: RETENTION_MODAL_STATUS, data: status };
};

export const setBifurcationModalStatus = status => {
  return { type: BIFURCATION_MODAL_STATUS, data: status };
};

export const setToastMsg = data => {
  return { type: SET_TOAST_MSG, payload: data };
};

export const setLoginError = error => {
  return { type: SET_LOGIN_ERROR, payload: error };
};

export const clearToast = () => {
  return { type: CLEAR_TOAST_MSG };
};

export const addBanner = data => {
  return {
    type: ADD_BANNER,
    payload: data,
  };
};

export const removeBanner = data => {
  return {
    type: REMOVE_BANNER,
    payload: data,
  };
};

export function logoutUserSuccess() {
  return {
    type: LOGOUT_USER_SUCCESS,
  };
}

export function setLoadingState(data) {
  return {
    type: SET_LOADING_STATE,
    payload: data,
  };
}

export function setGlobalTrayEnabledState(data) {
  return {
    type: SET_GLOBAL_TRAY_ENABLED_STATE,
    payload: data,
  };
}

export function setGlobalTrayRetracted(data) {
  return {
    type: SET_GLOBAL_TRAY_RETRACTED_STATE,
    payload: data,
  };
}

export function setGlobalTrayUnreadCount(data) {
  return {
    type: SET_GLOBAL_TRAY_UNREAD_COUNT,
    payload: data,
  };
}

export const setActiveTab = data => {
  return { type: SET_ACTIVE_TAB, payload: data };
};

export const setCurrentPageTitle = data => {
  return { type: SET_CURRENT_PAGE_TITLE, payload: data };
};

export const updateUserInfo = data => {
  return { type: UPDATE_USER_INFO, payload: data };
};

export const updateInvitedFamilyData = data => {
  return { type: UPDATE_INVITED_FAMILY_DATA, payload: data };
};

export const updateInvitedFamilyChildData = data => {
  return { type: UPDATE_INVITED_FAMILY_CHILD_DATA, payload: data };
};

export const updateOrganizationSwitcherDetails = data => {
  return {
    type: UPDATE_ORGANIZATION_SWITCHER_DETAILS,
    payload: data,
  };
};

export const setBifurcationAction = data => {
  return {
    type: SET_BIFURCATION_ACTION,
    payload: data,
  };
};

export const setShortcutToastVisibility = data => {
  return {
    type: SET_SHORTCUT_TOAST_VISIBILITY,
    payload: data,
  };
};

export const setRedirectUrl = data => {
  return {
    type: SET_REDIRECT_URL,
    payload: data,
  };
};

export const setUserComingFromPublicAccess = data => {
  return {
    type: SET_IS_USER_FROM_PUBLIC_ACCESS,
    payload: data,
  };
};

export const setIsLastChildRemoved = data => {
  return {
    type: SET_LAST_CHILD_STATUS,
    payload: data,
  };
};

export const setChildStatus = data => {
  return {
    type: SET_CHILD_STATUS,
    payload: data,
  };
};

export const setIsUnmappedParent = data => {
  return {
    type: SET_IS_UNMAPPED_PARENT,
    payload: data,
  };
};

export const setProductUpdateDirectLinkOpen = data => {
  return {
    type: SET_PRODUCT_UPDATE_DIRECT_LINK,
    payload: data,
  };
};

export const setChildData = data => {
  return {
    type: SET_CHILD_DATA,
    payload: data,
  };
};

export const setProductUpdateModalOpen = data => {
  return {
    type: SET_PRODUCT_UPDATE_MODAL_OPEN,
    payload: data,
  };
};

export const setProductUpdateModalVisible = data => {
  return {
    type: SET_PRODUCT_UPDATE_MODAL_VISIBLE,
    payload: data,
  };
};

export const setCurrentParentLoginTab = data => {
  return {
    type: SET_PARENT_LOGIN_TAB,
    payload: data,
  };
};

export const setIdentityPoolDetails = data => {
  return {
    type: SET_IDENTITY_POOL_DETAILS,
    payload: data,
  };
};

export const setUserIdentityDetails = data => {
  return {
    type: SET_USER_IDENTITY_DETAILS,
    payload: data,
  };
};

export const setIdentityScreenFilters = data => {
  return {
    type: SET_IDENTITY_SCREEN_FILTERS,
    payload: data,
  };
};

export const setAuthRegion = data => {
  return {
    type: SET_AUTH_REGION,
    payload: data,
  };
};

export const setPortalType = data => {
  return {
    type: SET_PORTAL_TYPE,
    payload: data,
  };
};

export const setSelectedGlobalTrayIcon = data => {
  return {
    type: SET_SELECTED_ICON,
    payload: data,
  };
};

export const setMessagingUser = data => {
  return {
    type: SET_MESSAGING_USER_ID,
    payload: data,
  };
};

export const setMessagingChatId = data => {
  return {
    type: SET_MESSAGING_CHAT_ID,
    payload: data,
  };
};

export const setUnderMaintenance = data => {
  return {
    type: SET_UNDER_MAINTENANCE,
    payload: data,
  };
};

export const setParentInviteCode = data => {
  return {
    type: SET_PARENT_INVITE_CODE,
    payload: data,
  };
};

export const toggleIsSprinklrChatOpen = data => {
  return { type: TOGGLE_IS_SPRINKLR_CHAT_OPEN, data };
};

export const setSprinklrUnreadMessageCount = data => {
  return { type: UPDATE_SPRINKLR_UNREAD_MESSAGE_COUNT, data };
};

export const setIsUserConfigurationsFetched = data => {
  return { type: SET_IS_USER_CONFIGURATIONS_FETCHED, data };
};

export const setPublicToken = data => {
  return { type: SET_PUBLIC_TOKEN, payload: data };
};

export const setGlobalHeaderVisibility = visibility => {
  return {
    type: SET_GLOBAL_HEADER_VISIBILITY,
    payload: visibility,
  };
};

const _setGlobalHeaderVisibilityOnCurrentRoute = isVisible => {
  return {
    type: SET_GLOBAL_HEADER_VISIBILITY_ON_CURRENT_ROUTE,
    payload: isVisible,
  };
};

export const setDemoDayVisibility = visibility => {
  return {
    type: SET_DEMO_DAY_BANNER_VISIBILITY,
    payload: visibility,
  };
};

export const updateSessionVerificationDetails = data => {
  return {
    type: UPDATE_SESSION_VERIFICATION_DETAILS,
    payload: data,
  };
};

export const setOrgWorkSpaceDetails = data => {
  return {
    type: SET_ORG_WORKSPACE_DETAILS,
    payload: data,
  };
};

export const clearOrgWorkSpaceDetails = data => {
  return {
    type: CLEAR_ORG_WORKSPACE_DETAILS,
    payload: data,
  };
};

export const updateChildId = data => {
  return {
    type: SET_CHILD_ID,
    payload: data,
  };
};

export const setSentralPortalDetails = data => {
  return {
    type: SENTRAL_PORTAL_DETAILS,
    payload: data,
  };
};

export const setSsoRequestInitiatedFailed = data => {
  return {
    type: SET_SSO_REQUEST_INITIATED_FAILED,
    payload: data,
  };
};

export const setSamlInitiatedDetails = data => {
  return {
    type: SET_SAML_INITIATED_DETAILS,
    payload: data,
  };
};

export const updateMfaVerificationDetails = data => {
  return { type: UPDATE_MFA_VERIFICATION_DETAILS, payload: data };
};

export const setupMfaVerificationDetails = data => {
  return { type: SETUP_MFA_VERIFICATION_DETAILS, payload: data };
};

// Auto-generated exports
export { _setGlobalHeaderVisibilityOnCurrentRoute };
